<template>
  <div class="center-flex">
    <div class="menu pointer" @click="goBack">
      <svg x="0px" y="0px" viewBox="0 0 31.494 31.494" style="enable-background:new 0 0 31.494 31.494;" xml:space="preserve">
        <path style="fill:#1E201D;" d="M10.273,5.009c0.444-0.444,1.143-0.444,1.587,0c0.429,0.429,0.429,1.143,0,1.571l-8.047,8.047h26.554
	          c0.619,0,1.127,0.492,1.127,1.111c0,0.619-0.508,1.127-1.127,1.127H3.813l8.047,8.032c0.429,0.444,0.429,1.159,0,1.587
	          c-0.444,0.444-1.143,0.444-1.587,0l-9.952-9.952c-0.429-0.429-0.429-1.143,0-1.571L10.273,5.009z"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForceBack',
  props: {
    forceBack: {
      type: Object,
      required: true
    }
  },
  methods: {
    goBack () {
      this.$router.go(this.forceBack.distance)
    }
  }
}
</script>

<style scoped lang="scss">
  .center-flex {
    display: flex;
    justify-content: center;
  }
  .border-bottom-1 {
    border-bottom: 1px solid;
  }
  .smash-right {
    margin-left: auto;
  }
  .pointer {
    cursor: pointer;
  }
  .fullscreenme {
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(255,255,255,0.95);
    z-index: 1;
    width: 100%;
    height: 100%;
  }
  .full-svg {
    height: 100%;
    width: 100%;
  }
  .menu {
    // min-width: 10em;
    height: 2em;
    width: 2em;
    align-items: center;
  }
  .top-bar {
    height: 4em;
  }
  .nav-link--mobile {
    padding: 1em;
    border-bottom: 1px solid;
    border-radius: 0;
  }

  .slide-left-enter-active, .slide-left-leave-active {
    transition: all .3s ease;
  }
  .slide-left-enter, .slide-left-leave-to {
    transform: translateX(-10px);
    opacity: 0;
  }
</style>
